var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.326,
    height: 9.205,
    viewBox: "0 0 8.326 9.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.771,9.2h-.15a1.107,1.107,0,0,0,.15-.555V.555A1.107,1.107,0,0,0,7.621,0h.15a.556.556,0,0,1,.555.555V8.65a.555.555,0,0,1-.555.555Zm-1.11,0H1.11A1.11,1.11,0,0,1,0,8.095V1.11A1.11,1.11,0,0,1,1.11,0h5.55a.556.556,0,0,1,.555.555V8.65A.556.556,0,0,1,6.661,9.2ZM3.431,4.893A2.036,2.036,0,0,0,2.3,5.31a1.3,1.3,0,0,0-.608,1.007c0,.171-.011.331-.021.486-.025.366-.044.656.1.813a.493.493,0,0,0,.378.125H5.064a.493.493,0,0,0,.378-.125c.147-.157.127-.447.1-.813-.011-.155-.021-.315-.021-.486A1.3,1.3,0,0,0,4.915,5.31a2.037,2.037,0,0,0-1.13-.417H3.431Zm.177-2.982A1.27,1.27,0,0,0,2.339,3.181c0,.709.332,1.536,1.269,1.536,1.1,0,1.269-.962,1.269-1.536A1.27,1.27,0,0,0,3.608,1.912Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBook);
export default __webpack_public_path__ + "static/media/phoneBook.c4569d81d0ab57905db7d057bdf926b1.svg";
export { ForwardRef as ReactComponent };